import React from "react";

import { FaSyncAlt } from "react-icons/fa";

// import { ToastContainer } from "react-toastify";

// import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../hooks/useScollToTop";

import MessagesSection from "./MessagesSection";
import VisitsChart from "./VisitsChart";

import useDashboardData from "./hooks/useDashboardData";

import { DashboardCard, SectionHeader } from "./ui/DashboardUI";

import UsersStatsSection from "./components/UsersStatsSection";
import StructureStatsSection from "./components/StructureStatsSection";
import AbonnementsSection from "./components/AbonnementsSection";

export default function Dashboard() {
  useScrollToTop();

  const {
    userStats,
    structureStats,
    abonnementStats,
    reglements,
    reglementUsers,
    clubsByUser,
    loading,
    savingReglement,
    lastUpdated,

    refreshAll,
    createPurchase,
    updatePurchase,
    removePurchase,
    loadClubForUser,
  } = useDashboardData();

  return (
    <div className="w-full px-4 pb-10 pt-28 font-satoshi">
      <div className="mx-auto">
        <header className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 dark:text-white sm:text-3xl">
              Tableau de bord Administratif
            </h1>

            <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
              Utilisateurs, structure, abonnements, messages et trafic.
            </p>

            <p className="mt-2 text-xs text-slate-500">
              {lastUpdated
                ? `Dernière mise à jour : ${lastUpdated.toLocaleString("fr-FR")}`
                : "Chargement des données..."}
            </p>
          </div>

          <button
            type="button"
            onClick={refreshAll}
            disabled={loading.refreshing}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 font-semibold text-white shadow-sm transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"
          >
            <FaSyncAlt className={loading.refreshing ? "animate-spin" : ""} />

            {loading.refreshing ? "Actualisation..." : "Rafraîchir"}
          </button>
        </header>

        <DashboardCard className="mb-6 p-4 sm:p-6">
          <SectionHeader
            title="Messages"
            subtitle="Lecture, recherche et gestion du formulaire de contact."
          />

          <MessagesSection />
        </DashboardCard>

        <UsersStatsSection stats={userStats} loading={loading.users} />

        <StructureStatsSection
          stats={structureStats}
          loading={loading.structure}
        />

        <AbonnementsSection
          stats={abonnementStats}
          reglements={reglements}
          users={reglementUsers}
          clubsByUser={clubsByUser}
          loadingStats={loading.abonnements}
          loadingReglements={loading.reglements}
          loadingUsers={loading.reglementUsers}
          loadingClubs={loading.clubs}
          saving={savingReglement}
          onLoadUserClub={loadClubForUser}
          onCreate={createPurchase}
          onUpdate={updatePurchase}
          onDelete={removePurchase}
        />

        <DashboardCard className="p-4 sm:p-6">
          <SectionHeader
            title="Trafic"
            subtitle="Évolution des visites et nettoyage des données."
          />

          <VisitsChart />
        </DashboardCard>
      </div>

      {/* <ToastContainer
        position="bottom-right"
        autoClose={3500}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      /> */}
    </div>
  );
}
